import $ from '@rover/globals/jquery';
import dataLayer from '@rover/globals/dataLayer';

import Alerts from '@rover/utilities/Alerts';
import { initIntlTelInput, updateCleaveForInputs } from '../components/intl_tel_input';

export default class AppInstallSMSForm {
  static init($el) {
    const $intlTelInput = initIntlTelInput('.js-send-to-phone-phone-number');
    $intlTelInput.each(updateCleaveForInputs);
    $intlTelInput.on('countrychange', updateCleaveForInputs);

    $el.autoDisableAjaxForm({
      beforeSerialize() {
        $('input[name=phone_number]').val($intlTelInput.intlTelInput('getNumber'));
      },
      error: (xhr, statusText, httpStatusText, $form) => {
        // Clear out any other alert containers
        $('.js-send-to-phone-message-container')
          .children()
          .remove();
        Alerts.showToast({
          severity: 'danger',
          message: xhr.responseJSON.message,
          container: '.js-send-to-phone-message-container',
        });
        dataLayer.push({
          event: 'owner-events-app-download-text-me-a-link',
          submitStatus: 'fail',
          errorMessage: xhr.responseJSON.message,
        });
      },
      success: (response, statusText, xhr, $form) => {
        // Clear out any other alert containers
        $('.js-send-to-phone-message-container')
          .children()
          .remove();
        $('.js-send-to-phone-phone-number').intlTelInput('setNumber', '');
        Alerts.showToast({
          severity: 'success',
          message: xhr.responseJSON.message,
          container: '.js-send-to-phone-message-container',
        });
        dataLayer.push({
          event: 'owner-events-app-download-text-me-a-link',
          submitStatus: 'success',
          errorMessage: null,
        });
        $form.trigger('message-sent');
      },
    });
  }
}



// WEBPACK FOOTER //
// ./js/forms/AppInstallSMSForm.js